export default __webpack_public_path__ + "lines_mobile@2x.e631d1d1.png";